import http from "../http-common";

export const getActionLogsForDay = (date) => {
  return http.get("/action-log", { params: { date } });
};

export const trackActionLog = (payload = {}) => {
  return http.post("/action-log", payload);
};
